import http from './http'
import config from './config'


export default {
	massPublishTiktop:async function(payload) {
		const res = await http({
			url: config.MASS_PUSHBLISH_GOODS,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},

	setVirtualSku:async function(payload) {
		const res = await http({
			url: config.BIND_VARTRAL_SKU,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},

	getStatusTikTokPublish:async function(payload) {
		const res = await http({
			url: config.GET_STATUS_PUBLISH_TIKTOP,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},

	getSkusPurchaseInfo:async function(payload) {
		const res = await http({
			url: config.GET_PURCHASE_SKUSINFO,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},

	getLazadaProDetail:async function(payload) {
		const res = await http({
			url: config.GET_LAZADA_PRODUCT_DETAIL,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	delistedProducts:async function(payload) {
		const res = await http({
			url: config.DELISTED_PRODUCTS,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},

	getAgencyProductInfo:async function(payload) {
		const res = await http({
			url: config.GET_AGENTS_FROMGROUPID,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},

	getPublishStoreId:async function(payload) {
		const res = await http({
			url: config.GET_PUBLISH_STORE,
			method: 'GET',
		})
		return res.data
	},

	downloadDxsOrderExcelFile:async function(payload) {
		const res = await http({
			url: config.DOWNLOAD_MODEL_EXCEL,
			method: 'GET',
		})
		return res.data
	},

	uploadShopeeByImgUrl:async function(payload) {
		const res = await http({
			url: config.UPLOAD_IMG_TOSHOPEE,
			method: 'put',
			data:{
				...payload
			}
		})
		return res.data
	},

	updataItemOnline:async function(payload) {
		const res = await http({
			url: config.UPDATA_ONLINE_ITEM,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	updateFbsRule:async function(payload) {
		const res = await http({
			url: config.UPDATE_FBS_RULE,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	remotePorderAndWorder:async function(payload) {
		const res = await http({
			url: config.REMOTE_PUCHCHASE_GODOWN,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	deleteWaterImg:async function(payload) {
		const res = await http({
			url: config.DELETE_WATERIMG,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	getWaterImg:async function(payload) {
		const res = await http({
			url: config.GET_WATERIMG,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	uploadWaterImg:async function(payload) {
		const res = await http({
			url: config.UPLOAD_WATERIMG,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	placeDxsOrder:async function(payload) {
		const res = await http({
			url: config.PLACE_DXS_ORDER,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	getDXSProduct:async function(payload) {
		const res = await http({
			url: config.GET_DXS_PRODUCT,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	publishProductToDXS:async function(payload) {
		const res = await http({
			url: config.PUBLISH_TO_DXS,
			method: 'POST',
			data:{
				...payload
			}
		})
		return res.data
	},
	getUserAuditLimit:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GETUSER_AUDITLIMIT,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	updateUserAuditLimit:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATEUSER_AUDITLIMIT,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	getUserCache:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_USERCACHE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	setUserCache:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_SET_USERCACHE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	updateShopRemark:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATE_SHOP_REMARK,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	updateStoreItemDetail:async function(payload) {
		const res = await http({
			url: config.SELLER_UPDATE_STORE_ITEM_DETAIL,
			method: 'post',
			data:payload
	
		})
		return res.data
	},

	getCorrelation:async function(payload) {
		const res = await http({
			url: config.GET_CORRELATION_DATA,
			method: 'post',
			data:payload
	
		})
		return res.data
	},

	batchTransferStoreNum:async function(payload) {
		const res = await http({
			url: config.BATCH_TRANSFET_STOREITEM,
			method: 'post',
			data:payload
	
		})
		return res.data
	},

	updatelimitAgencyNum:async function(payload) {
		const res = await http({
			url: config.UPDATE_LIMITAGENCYNUM,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	getStoreItemByGroupId:async function(payload) {
		const res = await http({
			url: config.GET_STOREITEM_BY_GROUPID,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	getCategoryByStoreItem:async function(payload) {
		const res = await http({
			url: config.GET_CATEGORY_BY_STOREITEM,
			method: 'get',
	
		})
		return res.data
	},

	getlazadaOrderByOrderId:async function(payload) {
		const res = await http({
			url: config.GET_ORDERS_BY_ORDERID_LAZAD,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	scrapedProdcutItem:async function(payload) {
		const res = await http({
			url: config.SCRAPE_DATA,
			method: 'post',
			data:{
				...payload
				
			},
			
	
		})
		return res.data
	},


	getOrderByOrderIds:async function(payload) {
		const res = await http({
			url: config.GET_ORDERS_BY_ORDERID,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	

	transferStoreNum:async function(payload) {
		const res = await http({
			url: config.TRANSFER_STORE_NUM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	checkPayAgencyFee:async function(payload) {
		const res = await http({
			url: config.CHECK_PAY_AGENCYFEE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	copyStoreItem:async function(payload) {
		const res = await http({
			url: config.COPY_STROE_ITEM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getPublicStoreItem:async function(payload) {
		const res = await http({
			url: config.GET_PUBLIC_STOREITEM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	updatePutAway:async function(payload) {
		const res = await http({
			url: config.UPDATE_PUT_AWAY,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getShopLogisticsAndAttribute:async function(payload) {
		const res = await http({
			url: config.GET_SHOP_LOGISTICS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
    getProductByids:async function(payload) {
		const res = await http({
			url: config.GET_PRODUCT_BY_ID,
			method: 'get',
			data: payload
		})
		return res.data
	},
    getStoreItemByGroup:async function(payload) {
		const res = await http({
			url: config.GET_STOREITEM_BY_GROUP,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	buyerUser:async function(payload) {
		const res = await http({
			url: config.BUYSER_ORDERS,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	getUserPictureImg:async function(payload) {
		const res = await http({
			url: config.GET_USER_CATEgory,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	getUserPictureData:async function(payload) {
		const res = await http({
			url: config.CATEGORY_BUYER_USER,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	addStoreItemGroupNotProduct:async function(payload) {
		const res = await http({
			url: config.ADD_WHOLE_STOREITEM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	publishProducts:async function(payload) {
		const res = await http({
			url: config.PUBLISH_PRODUCT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getCategoryByCountry:async function(payload) {
		const res = await http({
			url: config.GET_CATEGORY_COUNTRY,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	deleteParentMoadel:async function(payload) {
		const res = await http({
			url: config.DELETE_PRODUCT_MODEL_ALL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	freeApplyOrderApply:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_APPLY,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	freeApplyOrderAuditOrderAll:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_AUDITORDERALL,
			method: 'post',
			data: payload
		})
		return res.data
	},
	freeApplyOrderAuditUnPassOrderAll:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_AUDITUNPASSORDERALL,
			method: 'post',
			data: payload
		})
		return res.data
	},
	freeApplyOrderQueryApplyOrders:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_QUERYAPPLYORDERS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	freeApplyOrderReturn:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_RETURN,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	freeApplyOrderReturnJF:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_RETURNJF,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	freeApplyOrderCreat:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_CREAT,
			method: 'post',
			data: payload
		})
		return res.data
	},
	freeApplyOrderUpload:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_UPLOAD,
			method: 'post',
			data: payload
		})
		return res.data
	},
	freeApplyOrderGet:async function(payload) {
		const res = await http({
			url: config.FREEAPPLYORDER_GET,
			method: 'post',
			data: payload
		})
		return res.data
	},
	deleteChildrenMoadel:async function(payload) {
		const res = await http({
			url: config.DELETE_PRODUCT_MODEL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	getAttributes:async function(payload) {
		const res = await http({
			url: config.GET_ATTRIBUTES_BY_COUNTRY,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getUserProductModel:async function(payload) {
		const res = await http({
			url: config.GET_USER_PRODUCT_MODELS_BYID,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	getItemAttribute:async function(payload) {
		const res = await http({
			url: config.GET_ITEM_ATTRIBUTE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	updataProduct:async function(payload) {
		console.log(111)
		console.log(payload)
		const res = await http({
			url: config.ADD_PRODUCT_MODEL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	createProductModel:async function(payload) {
		const res = await http({
			url: config.UPDATE_PRODUCT_MODEL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},


	getUserProduct:async function(payload) {
		const res = await http({
			url: config.GET_USER_PRODUCT_MODELS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	uploadImg:async function(payload) {
		const res = await http({
			url: config.UPLOAD_IMG,
			method: 'post',
			data: payload,
		})
		return res.data
	},
	uploadFile:async function(payload) {
		const res = await http({
			url: config.UPLOAD_FILE,
			method: 'post',
			data: payload,
		})
		return res.data
	},

	updateReservedStock:async function(payload) {
		const res = await http({
			url: config.UPDATA_RESERVED_STOCK,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	updateAutoReserved:async function(payload) {
		const res = await http({
			url: config.UPDATA_AUTO_RESERVED,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	printeOrderAndPicklist:async function(payload) {
		const res = await http({
			url: config.PRINT_ORDER_AND_PICKLIST,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getPurchaseOrderNum:async function(payload) {
		const res = await http({
			url: config.GET_PURCHASEORDER_NUM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	printPdf:async function(payload) {
		const res = await http({
			url: config.PRINT_PDF,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
   updateProductId:async function(payload) {
		const res = await http({
			url: config.UPDATA_PRODUCTID,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	getProductByproductId:async function(payload) {
		const res = await http({
			url: config.GET_PRODUCT_ID,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	getCategoryByshops:async function(payload) {
		const res = await http({
			url: config.GET_CATEGORY_BY_SHOPS,
			method: 'post',
			data: payload
		})
		return res.data
	},
	
	copyStoreItem:async function(payload) {
		const res = await http({
			url: config.COPY_STORE_ITEM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	//匹配SKU绑定仓库商品
	bindBYsku:async function(payload) {
		const res = await http({
			url: config.BIND_BY_SKU,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	addShop: async function() {
		const res = await http({
			url: config.ADD_SHOP,
			method: 'get',
		})
		console.log(res.data)
		return res.data
	},

	getShopInfo: async function() {
		const res = await http({
			url: config.GET_SHOP_INFO,
			method: 'get',
			data: {
				shop_id: '235415214'
			}
		})
		console.log(res.data)
		return res.data
	},

	getAllShopInfo: async function() {
		const res = await http({
			url: config.GET_SHOP_ALL_INFO,
			method: 'get',
		})
		return res.data
	},

	//用userId获取订单列表
	getOrderList:async function(payload) {
		const res = await http({
			url:config.GEI_ORDER_BY_USERID,
			method:'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	

	

	



	//获取商店内所有的商品信息
	getShopAllItems: async function(payload) {
		const res = await http({
			url: config.GET_SHOP_ITEMS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	getIndustialBelt: async function(payload) {
		const res = await http({
			url: config.GET_INDUSTIAL_BELT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	//登录
	getLoginIn: async function(payload) {
		const res = await http({
			url: config.GET_LOGIN_IN,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//绑定商店
	getLockShopID: async function(payload) {
		const res = await http({
			url: config.GEI_LOCK_SHOP_ID,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取绑定的商店
	getShopItems: async function(payload) {
		const res = await http({
			url: config.GET_SHOPS,
			method: 'get',
			data: {
				userId: payload
			}
		})
		return res.data
	},
	//创建采购单
	createPurchaseOrder: async function(payload) {
		const res = await http({
			url: config.CREATE_CAIGUO_TABLE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	bindItem: async function(payload) {
		const res = await http({
			url:config.BIGN_ITEMS,
			method: 'post',
			data: payload
		})
		return res.data
	},
	getPurchaseOrderByUserId:async function(payload) {
		const res = await http({
			url: config.GET_PURCHASE_ORDER_BY_USER_ID,
			method: 'get',
			data: {
				userId:payload
			}
		})
		return res.data
	},
	// //获取商品详细信息
	// getItemDetail:async function(payload) {
	// 	const res = await http({
	// 		url: config.GET_SHOP_VARIATIONS,
	// 		method: 'post',
	// 		data: payload
	// 	})
	// 	return res.data
	// },

	
	//创建仓库
	createWarehouse:async function(payload) {
		const res = await http({
			url :config.CREATE_WAREHOUSE_BYSTORE,
			method:'post',
			data:{
				...payload
			}
		})
		return res.data 
	},
	//获取卖家账号已经绑定的所有仓库
	searchWarehouse:async function(payload) {
		const res = await http({
			url :config.SEARCH_WAREHOUSE,
			method:'get',
			data:{
				userId:payload
			}
		})
		return res.data 
	},
	//绑定仓库
	bindWarehouse:async function(payload) {
		const res = await http({
			url : config.BIND_STORE,
			method:'post',
			data:{
				...payload
			}
		})
		return res.data 
	},
	//审核订单
	
	auditOrder: async function(payload) {
		const res = await http ({
			url :config.AUDIT_ALL_ORDER,
			method:'post',
			data:payload,
			
		})
		return res.data 
	},
	//获取卖家用户所有的仓库
	getSellerStore:async function(payload) {
		const res = await http ({
			url :config.GET_SELLER_STORE,
			method:'get',
			data:{
				userId:payload
			}
		})
		return res.data 
	},
	//确认采购单
	auditPurchaseOrder: async function(payload) {
		const res = await http ({
			url :config.AUDITOR_PURCHASE_ORDER,
			method:'post',
			data:{
				...payload
			}
		})
		return res.data 
	},
	auditCH:async function(payload) {
		const res = await http ({
			url :config.AUDITCH,
			method:'post',
			data:{
				...payload
			}
		})
		return res.data 
	},
	// getShopStockRemind:async function(payload) {
	// 	const res = await http ({
	// 		url :config.STORE_REMIND,
	// 		method:'get',
	// 		data:{
	// 			...payload
	// 		}
	// 	})
	// 	return res.data 
	// },
	
	
	//获取打印面单
	getPrintOrder: async function(payload) {
		const res=await http({
			url:config.PRINT_ORDER_BY_shopee,
			method:'post',
			data:payload
		})
		return res.data
	},
	//注册帐号
	getRegistor: async function(payload) {
		const res=await http({
			url:config.GET_REGISTOR,
			method:'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	//获取所有店铺或某些商店的订单总数
	getOrderCountTotal: async function(payload) {
		const res = await http({
			url: config.GET_ORDER_TOTAL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	updateItems: async function(payload) {
		const res = await http({
			url: config.UPDATE_ITEMS,
			method: 'post',
			data: {
				shopId:payload
			}
		})
		return res.data
	},
	//获取翻译收费标准
	getintegral: async function(payload) {
		const res = await http({
			url: config.GET_INTEGRAL,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	//添加翻译收费标准
	insertintegral: async function(payload) {
		const res = await http({
			url: config.INSERT_INTEGRAL,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	//删除翻译收费标准
	deleteintegral: async function(payload) {
		const res = await http({
			url: config.DELETE_INTEGRAL,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	//更新翻译收费标准
	updateintegral: async function(payload) {
		const res = await http({
			url: config.UPDATE_INTEGRAL,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	//获取采购单列表
	getpurchase: async function(payload) {
		const res = await http({
			url: config.GET_PURCHASE,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	cteatesup: async function(payload) {
		const res = await http({
			url: config.CREATE_SUP,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	getsuplist: async function(payload) {
		const res = await http({
			url: config.GET_SUPLIST,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	deletesup: async function(payload) {
		const res = await http({
			url: config.DELETE_SUP,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	updatesup: async function(payload) {
		const res = await http({
			url: config.UPDATE_SUP,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	createpur: async function(payload) {
		const res = await http({
			url: config.CREATE_PUR,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getuserhouse: async function(payload) {
		const res = await http({
			url: config.GET_USERHOUSE,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	deletepurord: async function(payload) {
		const res = await http({
			url: config.DELETE_PUROR,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getorderdetil: async function(payload) {
		const res = await http({
			url: config.GET_PURDETIL,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	createware: async function(payload) {
		const res = await http({
			url: config.CREATE_WAREHOUSE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	deleteware: async function(payload) {
		const res = await http({
			url: config.DELETE_WAREHOUSE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getsuodetails: async function(payload) {
		const res = await http({
			url: config.GET_SUPDETAILS,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	updatewarehouse: async function(payload) {
		const res = await http({
			url: config.UPDATE_WAREHOUSE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	auditpurchase: async function(payload) {
		const res = await http({
			url: config.AUDIT_PURCHSEE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	updatepurchase: async function(payload) {
		const res = await http({
			url: config.UPDATE_PUROR,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},//更新采购单

	updatepurchasestatus: async function(payload) {
		const res = await http({
			url: config.UPDATE_PURORSTATUS,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},//更新采购单

	getcomment: async function(payload) {
		const res = await http({
			url: config.GET_COMMENT,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	createcomment: async function(payload) {
		const res = await http({
			url: config.CREATE_COMMENT,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	setleader: async function(payload) {
		const res = await http({
			url: config.SET_LEADER,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	createattri: async function(payload) {
		const res = await http({
			url: config.CREATE_ATTRIBUTE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getattribute: async function(payload) {
		const res = await http({
			url: config.GET_ATTRIBUTE,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getproducts: async function(payload) {
		const res = await http({
			url: config.GET_PRODUCTS,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getpeodetail: async function(payload) {
		const res = await http({
			url: config.GET_PRO_DETAIL,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getaudit: async function(payload) {
		const res = await http({
			url: config.GET_AUDIT_ORDER,
			method: 'get',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	searchproduct: async function(payload) {
		const res = await http({
			url: config.SEARCH_PRODUCT,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	createproducts: async function(payload) {
		const res = await http({
			url: config.CREATE_PRODUCT,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	auditproducts: async function(payload) {
		const res = await http({
			url: config.AUDIT_PRODUCT,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},//更改产品状态

	deleteproduct: async function(payload) {
		const res = await http({
			url: config.DELETE_PRODUCR,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},

	getorderlistde: async function(payload) {
        const res = await http({
            url: config.ORDER_LIST_DE,
            method: 'post',
            data:{
                ...payload
            }
    
        })
        return res.data
    },

	updateproducts: async function(payload) {
		        const res = await http({
		            url: config.UPDATE_PRODUCTS,
		            method: 'post',
		            data:{
		                ...payload
		            }
		    
		        })
		        return res.data
		    },
	
		auditupdate: async function(payload) {
			        const res = await http({
			            url: config.audit_update,
			            method: 'post',
			            data:{
			                ...payload
			            }
			    
			        })
			        return res.data
			    },
			
			    searchorders: async function(payload) {
			        const res = await http({
			            url: config.SEARCH_ORDER,
			            method: 'post',
			            data:{
			                ...payload
			            }
			    
			        })
			        return res.data
			    },
			
			    searchcombine: async function(payload) {
			        const res = await http({
			            url: config.SEARCH_COMBINE,
			            method: 'post',
			            data:{
			                ...payload
			            }
			    
			        })
			        return res.data
			    },	
			getpuser:async function(payload) {
				        const res = await http({
				                url: config.GET_ALLPURUSER,
				                method: 'post',
				                data:{
				                    ...payload
				                }
				            })
				        return res.data
				      },
				
				      getcart:async function(payload) {
				        const res = await http({
				                url: config.GET_CART,
				                method: 'post',
				                data:{
				                    ...payload
				                }
				            })
				        return res.data
				      },
				
				      addcart:async function(payload) {
				        const res = await http({
				                url: config.ADD_CART,
				                method: 'post',
				                data:{
				                    ...payload
				                }
				            })
				        return res.data
				      },
				
				      removecart:async function(payload) {
				        const res = await http({
				                url: config.REMOVE_CART,
				                method: 'post',
				                data:{
				                    ...payload
				                }
				            })
				        return res.data
				      },
				
				      paymentorder:async function(payload) {
				        const res = await http({
				                url: config.PAYMENT_ORDER,
				                method: 'post',
				                data:{
				                    ...payload
				                }
				            })
				        return res.data
				      },
				
				      getgroupcart:async function(payload) {
				        const res = await http({
				                url: config.GET_GROUP_CART,
				                method: 'post',
				                data:{
				                    ...payload
				                }
				            })
				        return res.data
				      },
				
				      copycart:async function(payload) {
				        const res = await http({
				                url: config.COPY_CART,
				                method: 'post',
				                data:{
				                    ...payload
				                }
				            })
				        return res.data
				      },
}